module.exports = __webpack_public_path__ + "img/@team_img_02_.0270541f.jpg";